export const getChannelViewName = channelId => `channel-${channelId}`
export const NOTE_VIEW = 'note'
export const ORGANIZATION_VIEW = 'organization'
export const CHANNELS_LIST = 'channelsList'
export const TEMPLATE_VIEW = 'templateView'
